var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tableauJwtToken)?_c('div',{staticClass:"bdc_main_wrap whero"},[_c('tableau-viz',{attrs:{"id":"tableauViz","src":_vm.tableauURL,"token":_vm.tableauJwtToken,"toolbar":"top"}},[_c('custom-parameter',{attrs:{"name":":showShareOptions","value":"false"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }